module.exports = __webpack_public_path__ + "media/backgrounds/phone-bg-animation-090eb05c.png";